import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-lineage',
  templateUrl: './header-column-lineage.component.html',
  styleUrl: './header-column-lineage.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnLineageComponent extends HeaderColumnComponent {}
